import { CameraEventType, KeyboardEventModifier } from "cesium";
import { ControlsPreset } from "./ControlsPreset";

export const REVIZTO_CONTROLS_PRESET: ControlsPreset = {
  key: "revizto",
  group: "industry",
  display: {
    title: "Revizto",
    iconPath: "/images/revizto.png",
    subtitle: "For users familiar with Revizto",
    description:
      "For users familiar with Revizto, intuitive navigation with remapped key bindings.",
  },
  mappings: {
    pan: {
      display: {
        title: "Pan",
        instructions: "Middle click",
      },
      cesiumInputs: [
        { eventType: CameraEventType.MIDDLE_DRAG },
        {
          eventType: CameraEventType.LEFT_DRAG,
          modifier: KeyboardEventModifier.CTRL,
        },
      ],
    },
    orbitAroundPoint: {
      display: {
        title: "Orbit Around Point",
        instructions: "Left click",
      },
      cesiumInputs: [
        { eventType: CameraEventType.LEFT_DRAG },
        { eventType: CameraEventType.PINCH },
        {
          eventType: CameraEventType.RIGHT_DRAG,
          modifier: KeyboardEventModifier.CTRL,
        },
        {
          eventType: CameraEventType.MIDDLE_DRAG,
          modifier: KeyboardEventModifier.SHIFT,
        },
      ],
    },
    lookAround: {
      display: {
        title: "Look Around",
        instructions: "Right click",
      },
      cesiumInputs: [
        { eventType: CameraEventType.RIGHT_DRAG },
        {
          eventType: CameraEventType.LEFT_DRAG,
          modifier: KeyboardEventModifier.SHIFT,
        },
        {
          eventType: CameraEventType.LEFT_DRAG,
          modifier: KeyboardEventModifier.ALT,
        },
      ],
    },
    zoom: {
      cesiumInputs: [
        { eventType: CameraEventType.WHEEL },
        { eventType: CameraEventType.PINCH },
        {
          eventType: CameraEventType.RIGHT_DRAG,
          modifier: KeyboardEventModifier.SHIFT,
        },
      ],
    },
  },
};
